// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"e39e4de8","693":"c642170b","845":"d3f8d92e"}[chunkId] + ".chunk.js";
};